import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
// import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-income-summary-report',
  templateUrl: './income-summary-report.component.html',
  styleUrls: ['./income-summary-report.component.css']
})
export class IncomeSummaryReportComponent implements OnInit {

  public menu_item_id = '33';
  private dp = [];

  invoice_total = '0';
  supplier_invoice_total = '0';
  return_inv_total = '0';
  return_supp_inv_total = '0';
  final_total = '0';

  displayedColumns = ['title1', 'data1', 'title2', 'data2'];
  dataSource = new MatTableDataSource(this.dp);

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = { 'from_date': new Date(), 'to_date': new Date(), 'title': 'تقرير ملخص حركة المبيعات والمشتريات' };

  Income_Summary_Report; Sales_Calc; Purchases_Calc; Sales_Ret_Calc;
  Purchases_Ret_Calc; From_Date; To_Date; Amount_Total;
  From_Date_Msg; To_Date_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Income_Summary_Report').subscribe((res: string) => {
      this.Income_Summary_Report = res;
    });
    this.model['title'] = this.Income_Summary_Report;

    translate.get('Sales_Calc').subscribe((res: string) => {
      this.Sales_Calc = res;
    });

    translate.get('Purchases_Calc').subscribe((res: string) => {
      this.Purchases_Calc = res;
    });

    translate.get('Sales_Ret_Calc').subscribe((res: string) => {
      this.Sales_Ret_Calc = res;
    });

    translate.get('Purchases_Ret_Calc').subscribe((res: string) => {
      this.Purchases_Ret_Calc = res;
    });

    translate.get('From_Date').subscribe((res: string) => {
      this.From_Date = res;
    });

    translate.get('To_Date').subscribe((res: string) => {
      this.To_Date = res;
    });

    translate.get('Amount_Total').subscribe((res: string) => {
      this.Amount_Total = res;
    });

    translate.get('From_Date_Msg').subscribe((res: string) => {
      this.From_Date_Msg = res;
    });

    translate.get('To_Date_Msg').subscribe((res: string) => {
      this.To_Date_Msg = res;
    });

  }

  ngOnInit() {
    this.dp = [{ 'title1': this.Sales_Calc, 'data1': '0', 'title2': this.Purchases_Calc, 'data2': '0' },
    { 'title1': this.Sales_Ret_Calc, 'data1': '0', 'title2': this.Purchases_Ret_Calc, 'data2': '0' },
    { 'title1': this.Amount_Total, 'data1': '0', 'title2': '', 'data2': '' }];
    this.dataSource = new MatTableDataSource(this.dp);
    this.dataSource.sort = this.sort;

    this.search();
  }

  search() {

    if (this.model['from_date'] == undefined || this.model['from_date'].toString() == '') {
      alert(this.From_Date_Msg);
      return;
    }

    if (this.model['to_date'] == undefined || this.model['to_date'].toString() == '') {
      alert(this.To_Date_Msg);
      return;
    }

    this.invoice_total = '0';
    this.supplier_invoice_total = '0';
    this.return_inv_total = '0';
    this.return_supp_inv_total = '0';
    this.final_total = '0';

    let from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" +
      this.model['from_date'].getDate() + " 00:00:00";

    let to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" +
      this.model['to_date'].getDate() + " 23:59:59";

    let obj = { cmd: 'getIncomeSummary', from_date: from_date, to_date: to_date };
    this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
    .subscribe(data => {
      this.applicationConstants.appComp.hideBusyCursor();

      let result = data.data['list'];
      console.log(this.dp);

      this.invoice_total = result[0]['invoice_total'];
      this.supplier_invoice_total = result[0]['supplier_invoice_total'];
      this.return_inv_total = result[0]['return_total'];
      this.return_supp_inv_total = result[0]['return_supplier_total'];
      this.final_total = result[0]['final_total'];

      // fill dp 
      this.dp['0']['data1'] = this.invoice_total;
      this.dp['0']['data2'] = this.supplier_invoice_total;

      this.dp['1']['data1'] = this.return_inv_total;
      this.dp['1']['data2'] = this.return_supp_inv_total;

      this.dp['2']['data1'] = this.final_total;

      this.dataSource = new MatTableDataSource(this.dp);
      this.dataSource.sort = this.sort;
    });
  }

  print() {

    let from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" +
      this.model['from_date'].getDate();
    let to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" +
      this.model['to_date'].getDate();

    let html_data = '<table cellpadding="8" cellspacing="0">';
    // html_data += '<tr><td colspan="3"><h2> ' + this.Income_Summary_Report + ' </h2></td></tr>';
    html_data += '<tr><td width="45%"> ' + this.From_Date + ': ' + from_date + '</td><td> ' + this.To_Date + ': ' + to_date + '</td></tr>';
    html_data += '</table>';

    html_data += '<table cellspacing="0" style="width:100%;" border="1">';
    html_data += '<tr style="line-height: 28px;"><td class="labelTd" align="center" style="width:25%;"><label for="name"> ' + this.Sales_Calc + '</label></td>';
    html_data += '<td align="center" style="width:25%;">' + this.invoice_total + '</td>';
    html_data += '<td class="labelTd" align="center" style="width:25%;"><label for="name"> ' + this.Purchases_Calc + '</label>';
    html_data += '</td><td align="center" style="width:25%;">' + this.supplier_invoice_total + '</td> </tr>';
    html_data += '<tr style="line-height: 28px;"><td class="labelTd" align="center" style="width:25%;"><label for="name"> ' + this.Sales_Ret_Calc + '</label>';
    html_data += '</td><td align="center" style="width:25%;">' + this.return_inv_total + '</td>';
    html_data += '<td class="labelTd" align="center" style="width:25%;"><label for="name"> ' + this.Purchases_Ret_Calc + '</label>';
    html_data += '</td><td align="center" style="width:25%;">' + this.return_supp_inv_total + '</td></tr>';
    html_data += '<tr style="line-height: 28px;"><td class="labelTd" align="center" style="width:25%;"><label for="name"> ' + this.Amount_Total + '</label>';
    html_data += '</td><td colspan="3" align="center">' + this.final_total + '</td> </tr>';
    html_data += '</table>';

    let form = (document.getElementById('form1') as HTMLFormElement);
    // let table = (document.getElementById('rep_table2') as HTMLTableElement);
    this.utils.printReport(html_data, [], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

}
